import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-visit-or-refunds',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './visit-or-refunds.component.html',
  styleUrl: './visit-or-refunds.component.scss',
})
export class VisitOrRefundsComponent {}
